export const compradores = [
  { nombre: 'María L.', lugar: 'Rosario, Santa Fe' },
  { nombre: 'Julián P.', lugar: 'Córdoba Capital' },
  { nombre: 'Carolina M.', lugar: 'La Plata, Buenos Aires' },
  { nombre: 'Sofía R.', lugar: 'Mendoza' },
  { nombre: 'Gabriel A.', lugar: 'Mar del Plata, Buenos Aires' },
  { nombre: 'Valeria S.', lugar: 'San Miguel de Tucumán' },
  { nombre: 'Nicolás F.', lugar: 'Salta' },
  { nombre: 'Daniela C.', lugar: 'Neuquén' },
  { nombre: 'Martín G.', lugar: 'Bahía Blanca, Buenos Aires' },
  { nombre: 'Lucía B.', lugar: 'CABA' },
  { nombre: 'Federico T.', lugar: 'Santa Fe Capital' },
  { nombre: 'Romina D.', lugar: 'Paraná, Entre Ríos' },
  { nombre: 'Andrés V.', lugar: 'San Juan' },
  { nombre: 'Paula E.', lugar: 'Posadas, Misiones' },
  { nombre: 'Cecilia N.', lugar: 'Corrientes' },
  { nombre: 'Hernán O.', lugar: 'Río Cuarto, Córdoba' },
  { nombre: 'Agustina Q.', lugar: 'Resistencia, Chaco' },
  { nombre: 'Marcos I.', lugar: 'Comodoro Rivadavia, Chubut' },
  { nombre: 'Florencia H.', lugar: 'San Rafael, Mendoza' },
  { nombre: 'Diego U.', lugar: 'Quilmes, Buenos Aires' },
]

export const minutosDesdeCompra = [1, 2, 3, 4, 5, 6, 7, 8, 9, 11, 13, 16]
